import { render, staticRenderFns } from "./OrdersInboundHead.vue?vue&type=template&id=79af7bb8&scoped=true"
import script from "./OrdersInboundHead.vue?vue&type=script&lang=js"
export * from "./OrdersInboundHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af7bb8",
  null
  
)

export default component.exports